import TypeUtils from "@/helpers/type-utils";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime)


export default class ImportHistory {
  public id: string;
  public createat: Date;
  public replayat: Date;
  public filename: string;
  // Non renvoyé par les listes (trop volumineux) : chargé à la demande avec LogsDao.getRaw
  public raw: string;
  public hasNoData: boolean;
  public results: Record<string, { inserted: number, total: number }>;
  public success: boolean;

  public static map(data: Partial<ImportHistory>): ImportHistory {
    if (!data) {
      return null;
    }

    const history = new ImportHistory();
    history.id = TypeUtils.hasStringOrDefault(data.id, null);
    history.createat = TypeUtils.hasDateOrDefault(data.createat, new Date());
    history.replayat = TypeUtils.hasDateOrDefault(data.replayat, null);

    history.filename = TypeUtils.hasStringOrDefault(data.filename);

    // Test if string is base64
    if (data.raw && data.raw.match(/^[A-Za-z0-9+/]+={0,2}$/)) {
      history.raw = Buffer.from(data.raw, "base64").toString("utf8");
    } else {
      history.raw = TypeUtils.hasStringOrDefault(data.raw);
    }

    history.results = JSON.parse(TypeUtils.hasStringOrDefault(data.results));
    history.success = TypeUtils.hasBooleanOrDefault(data.success);
    // Fourni par l'API pour les listes ; sinon déduit du contenu brut
    history.hasNoData = data.hasNoData !== undefined ? TypeUtils.hasBooleanOrDefault(data.hasNoData) : !history.raw || history.raw == "null";

    return history;
  }

  get rawBase64(): string {
    if (!this.raw) {
      return "";
    }

    return Buffer.from(this.raw.toString()).toString("base64");
  }

  get hasNoTarget(): boolean {
    return this.hasNoData || Object.values(this.results || {}).every(it => it.inserted == 0);
  }

  get dateFormatted(): string {
    return dayjs(this.createat).format("YYYY-MM-DD HH:mm:ss");
  }

  get replayFormatted(): string {
    return this.replayat ? dayjs(this.replayat).format("YYYY-MM-DD HH:mm:ss") : "";
  }

  get isFullSuccess(): boolean {
    return this.success || this.isRetried
  }

  get isRetried(): boolean {
    return !!this.replayat;
  }

  get fromNow(): string {
    return dayjs(this.createat).fromNow();
  }
}
